import client from "@/plugins/axios-plugin";
import Vue from "vue";

export default async function (page) {
  const token = Vue.$cookies.get("token");
  if (!token) return null;
  try {
    const data = await client.get(`/device?page=${page}&total=10`, {
      headers: {
        authorization: token,
      },
    });
    return data.data;
  } catch (error) {}
  return null;
}
